import { render, staticRenderFns } from "./mobile.vue?vue&type=template&id=594d6dc8&scoped=true&"
import script from "./mobile.vue?vue&type=script&lang=ts&"
export * from "./mobile.vue?vue&type=script&lang=ts&"
import style0 from "./mobile.vue?vue&type=style&index=0&id=594d6dc8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594d6dc8",
  null
  
)

export default component.exports